/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claim_Outcome_RejectedInputs */

const en_claim_outcome_rejected = /** @type {(inputs: Claim_Outcome_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejected`)
};

/**
* | output |
* | --- |
* | "Rejected" |
*
* @param {Claim_Outcome_RejectedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const claim_outcome_rejected = /** @type {((inputs?: Claim_Outcome_RejectedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claim_Outcome_RejectedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_claim_outcome_rejected(inputs)
});